import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NavController, NavParams, ToastController } from "ionic-angular";
import { ModalController } from "ionic-angular";
import { AlertController, LoadingController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { ControlMessagesComponent } from '../../components/controlmessagecomponent/controlmessagecomponent';
import { ListComponent } from "../../components/listcomponent/listcomponent";
import { Member } from "../../models/interfaces/member.model";
import { Settings } from "../../models/interfaces/settings.model";
import { PledgeStatus } from "../../models/interfaces/pledgestatus.model";
import { Status } from "../../models/interfaces/status.model";
import { PledgeType } from "../../models/interfaces/pledgetype.model";
import { PledgePage } from "../../pages/pledge/pledge";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ValidationserviceProvider } from "../../providers/dbservice/validationservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-guest_add",
  templateUrl: "guest_add.html",
})
export class GuestAddPage {
  private dataFromOtherPage = null;
  private loading: any;
  private pledgetype$: Observable<PledgeType[]>;
  private guestfee$: Settings[];
  private tmpguestfee$: Settings[];
  private pledgestatus$: Observable<PledgeStatus[]>;
  private pledgeitem_by_name$ = [];
  private status$: Observable<Status[]>;
  private defpledgeitem$: Observable<Settings[]>;
  private member$: Observable<Member[]>;
  private memberForm: FormGroup;
  private pledgeForm: FormGroup;
  private guestForm: FormGroup;
  private pledgeItemForm: FormGroup;
  private member: Member;
  private gt_amount: number;
  private harelineid: string = null;
  private pl_date: string = new Date(new Date().getFullYear(), new Date().getMonth() , new Date().getDate() + 1).toISOString().substring(0, 10);
  private hl_runno = 0;
  private mb_id: number;
  private mb_hashname: string;
  private hl_id: number;
  private se_id: number;
  private pt_id: number;
  private pt_name: string;
  private ps_id: number;
  private ps_name: string;
  private st_id: number;
  private st_name: string;
  private se_key_value: number;
  private se_key_name: string;
  private styleName: string ="";
  private pl_remark: string;
  private pl_qty = 1;
  private pi_default_flg;


  constructor(private configService: ConfigService,public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    private formBuilder: FormBuilder, private toastCtrl: ToastController,
    private db: DbserviceProvider, public alertCtrl: AlertController,
    public loadingCtrl: LoadingController, public modalCtrl: ModalController,
  ) {
    console.log("GuestAddPage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");


    this.hl_runno = this.navParams.get("hareline")[0].hl_runno;
    this.hl_id = this.navParams.data.hareline[0].hl_id;
    this.gt_amount = this.navParams.data.hareline[0].hl_guestfee;

    this.guestForm = this.formBuilder.group({
      "hl_runno": ["", [Validators.required, Validators.min(1), Validators.max(9999)]],
      "gt_amount": "",
      "gt_name": ["", [Validators.required]],
      "gt_comment": [""],
      "gt_contact_mobile": ["+65", ""],
      "ps_id": ["", [Validators.required]],
      "st_id": ["", [Validators.required]],
      "ps_name": ["", [Validators.required]],
    });
    this.guestForm.controls.hl_runno.setValue(this.hl_runno);
    this.guestForm.controls.gt_amount.setValue(this.gt_amount);


    this.db.dbCol({
      "action": "select", "mapObject": "pledge_status",
      "sqlExtended": " order by pledge_status.ps_order"
    }).subscribe((ret) => {
      this.pledgestatus$ = ret;
      ret.forEach((element) => {
        // Set Default values and update form
        if (Number(element.ps_default_flg) === Number("1")) {
          this.ps_id = element.ps_id;
          this.ps_name = element.ps_name;
          this.guestForm.controls.ps_id.setValue(this.ps_id);
          this.guestForm.controls.ps_name.setValue(this.ps_name);
        }
      });
    });

    this.db.dbCol({
      "action": "select", "mapObject": "status",
      "sqlExtended": " where st_byfee_flg=1 order by status.st_order"
    }).subscribe((ret) => {
      this.status$ = ret;
      ret.forEach((element) => {
        // Set Default values and update form
        if (Number(element.st_default_flg) === Number("1")) {
          this.st_id = element.st_id;
          //this.st_name = element.st_name;
          this.guestForm.controls.st_id.setValue(this.st_id);
          //this.guestForm.controls.st_name.setValue(this.st_name);
        }
      });
    });

    this.db.dbCol({
      "action": "select", "mapObject": "settings",
      "sqlExtended": " where se_class = 'Guest' and se_key_name like '%Guest%' order by settings.se_order"
    }).subscribe((ret) => {
      this.guestfee$ = ret;
      this.tmpguestfee$ = this.guestfee$.filter(data => Number(data.se_default_flg) === Number(1));
      this.st_id=this.tmpguestfee$[0].st_id;
      this.guestForm.controls.st_id.setValue(this.st_id);
      //console.error("this.tmpguestfee$", this.tmpguestfee$);
      this.gt_amount=Number(this.tmpguestfee$[0].se_key_value);

    });

  }

  private ionViewWillEnter() {
    console.log("GuestAddPage ionViewWillEnter");
    this.onInitPage();
  }
  private callback = (data) => {
    this.dataFromOtherPage = data;
    console.log("data received from other page", this.dataFromOtherPage);
  }
  private onInitPage() {
    console.log("GuestAddPage onInitPage");
  }

  private openOtherPage() {
    this.navCtrl.push("OtherPage", {
      "callback": this.callback,
    });
  }

  private changeCategory(_st_id) {
    console.log("GuestAddPage changeCategory");

    this.tmpguestfee$ = this.guestfee$.filter(data => Number(data.st_id) === Number(_st_id));
    this.gt_amount=Number(this.tmpguestfee$[0].se_key_value);

  }


  private goback() {
    console.log("GuestAddPage goback");
    this.navCtrl.pop();
  }


  private addGuest(value: any) {
    console.log("GuestAddPage addGuest");

    const formValues: any = {
      "hl_id": this.hl_id,
      "ps_id": value.ps_id,
      "st_id": value.st_id,
      "gt_name": value.gt_name,
      "gt_comment": value.gt_comment,
      "gt_contact_mobile": value.gt_contact_mobile,
      "gt_amount": value.gt_amount,

    };

    this.db.dbCol({ "action": "insert", "mapObject": "guest", ...formValues })
      .subscribe();
    this.navCtrl.pop();
  }

  private ngOnDestroy() {
    console.log("GuestAddPage ngOnDestroy");
  }
}



// WEBPACK FOOTER //
// ./src/components/attendancecomponent/guest_add.ts